export default __webpack_public_path__ + "static/147-82a1c46318af4c77e416739531976a35.jpg";